<div class="open-trading-account7-wrapper">
	<div class="d-flex justify-content-center">
		<div class="col-12 col-md-6 col-xl-4 justify-content-center">


			<div class="inp-sec">
				<div class="google-pay-logo">
					<img alt="You are one step away from your phonepe exclusive offer" src="./assets/images/landing-img/phonepe.svg"/>
				</div>
				<h1 class="text-hdfc-blue font-weight-700 text-uppercase text-center">YOU ARE ONE STEP AWAY FROM YOUR <br/> OFFERS WORTH ₹ 3499* <a href="#" class="tc" data-toggle="modal" data-target="#modal-terms-phone-pay">T&C</a></h1>
				<p class="p-16 text-center">Open A Demat Account And <br>Claim Your Reward</p>

				<div class="form-body">
					<form>
						<div class="form-group">
							<input type="tel" class="form-control" aria-describedby="numbHelp" placeholder="Your 10 digit mobile number" id="txtMobile" name="txtMobile" [(ngModel)]="loginDetails.Mobile" maxlength="10" onkeypress="return !isNaN(event.key) || event.charCode == 13" autocomplete="off" />
						</div>

						<div class="form-group">
							<input class="form-control" placeholder="PhonePe Voucher Code" id="txtCode" name="txtCode" [(ngModel)]="loginDetails.Code" maxlength="15" autocomplete="off" />
						</div>

						<button type="button" class="btn btn-red" (click)="doLogin()">Start Journey</button>
					</form>

					<h2 class="text-hdfc-blue font-weight-700 text-uppercase text-center mt20 mb10">
						BRAND VOUCHER WORTH ₹ 500 + <br/> PREMIA SUBSCRIPTION WORTH ₹ 2999/-
					</h2>

					<div class="acct-3-sec">
						

						<div class="acct-3-sec-flex">
							<div class="zero-blk zero-blk-middle">
								<img alt="Premier technology" src="./assets/images/landing-img/zp.png" />
								<h3><strong class="font-weight-700">ZERO</strong><br> Paperwork & Account Opening Charges </h3>
							</div>
							<div class="zero-blk">
								<img alt="Premier technology" src="./assets/images/landing-img/zb.png" />
								<h3><strong class="font-weight-700">LOW</strong> <br>Brokerage plans</h3>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div class="form-body why-open-wrapper">
				<h2>Why open an <br>HDFC Demat & Trading Account?</h2>

				<div class="trading-facility-list">
					<div class="trading-facility-blk">
						<img alt="Single Access to all Securities" src="./assets/images/landing-img/why1.png" />
						<h3>Margin <br>Trading Facility</h3>
					</div>
					<div class="trading-facility-blk">
						<img alt="Trade Across Devices" src="./assets/images/landing-img/why4.png" />
						<h3>Relationship  <br>Manager Services</h3>
					</div>
					<div class="trading-facility-blk">
						<img alt="Zero Risk of Theft orgery, Loss or Damage " src="./assets/images/landing-img/why6.png" />
						<h3>Research  <br>Guidance</h3>
					</div>
					<div class="trading-facility-blk">
						<img alt="Apply for IPOs and Rights Issues" src="./assets/images/landing-img/why3.png" />
						<h3>Apply for  <br>IPOs in 3 clicks</h3>
					</div>
					<div class="trading-facility-blk">
						<img alt="Direct Credit of Stock Split and Bonus Shares" src="./assets/images/landing-img/why5.png" />
						<h3>Currency &  <br>Commodity <br>Trading</h3>
					</div>

					<div class="trading-facility-blk">
						<img alt="Quick and Efficient" src="./assets/images/landing-img/why2.png" />
						<h3>Quick and efficient transfer of Shares & Funds</h3>
					</div>
				</div>
			</div>

			<div class="form-body hdfc-securities-wrapper">
				<h2>HDFC securities 360<sup>o</sup> Advantage</h2>



				<div class="hdfc-securities-list">
					<div class="hdfc-advantage-blk">
						<img alt="ProTerminal" src="./assets/images/landing-img/Advantage1.png" />
						<div class="text-sec">
							<h3>ProTerminal</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="Research Support" src="./assets/images/landing-img/Advantage3.png" />
						<div class="text-sec">
							<h3>Research Support</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="Global Access#" src="./assets/images/landing-img/Advantage4.png" />
						<div class="text-sec">
							<h3>Global Access#</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="Call & Trade" src="./assets/images/landing-img/Advantage5.png" />
						<div class="text-sec">
							<h3>Call & Trade</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="24/7 assistance" src="./assets/images/landing-img/Advantage6.png" />
						<div class="text-sec">
							<h3>24/7 assistance</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="Quick Payout" src="./assets/images/landing-img/Advantage7.png" />
						<div class="text-sec">
							<h3>Quick Payout</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="2 Decades of Trust" src="./assets/images/landing-img/Advantage8.png" />
						<div class="text-sec">
							<h3>2 Decades <br>of Trust</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="Advance Portfolio Tracking" src="./assets/images/landing-img/Advantage9.png" />
						<div class="text-sec">
							<h3>Advance <br>Portfolio Tracking</h3>
						</div>
					</div>

					<div class="hdfc-advantage-blk">
						<img alt="End-to-end Investment Solution" src="./assets/images/landing-img/Advantage2.png" />
						<div class="text-sec">
							<h3>End-to-end Investment Solutions</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="form-body easy-steps">
				<h2>3 EASY STEPS TO OPEN AN <br>ACCOUNT ONLINE</h2>
				<div class="acct-3-sec">
					<div class="zero-blk easy-steps-blk">
						<img alt="Enter mobile number & OTP" src="./assets/images/landing-img/Step1.png" />
						<h3>Verify</h3>
						<p class="steps">1</p>
					</div>

					<div class="zero-blk easy-steps-blk easy-steps-blk-middle">
						<img alt="Enter Personal Details" src="./assets/images/landing-img/Step2.png" />
						<h3>Kyc</h3>
						<p class="steps">2</p>
					</div>
					<div class="zero-blk easy-steps-blk">
						<img alt="Add Bank Details" src="./assets/images/landing-img/Step3.png" />

						<h3>E - Sign</h3>
						<p class="steps">3</p>
					</div>
				</div>
			</div>



		</div>
	</div>
</div>
